<template>
  <div class="max-w-6xl mx-auto p-6">
    <h1 class="text-2xl font-bold mb-4">Бухгалтерия</h1>

    <!-- Summary Section -->
    <div class="mb-6 grid grid-cols-2 gap-y-2 text-gray-700">
      <p class="font-medium">Доход от врачей:</p><p>{{ summary.doctor_revenue }} ₸</p>
      <p class="font-medium">Доход от медсестер:</p><p>{{ summary.nurse_revenue }} ₸</p>
      <p class="font-medium">Общий доход:</p><p>{{ summary.total_revenue }} ₸</p>
      <p class="font-medium">Чистый доход (15%):</p><p>{{ netIncome }} ₸</p>
      <p class="font-medium">Отмены врачей:</p><p>{{ summary.doctor_cancellations }}</p>
      <p class="font-medium">Отмены медсестер:</p><p>{{ summary.nurse_cancellations }}</p>
      <p class="font-medium">Общие отмены:</p><p>{{ summary.total_cancellations }}</p>
    </div>

    <!-- Filters Section -->
    <div class="flex space-x-4 mb-6">
      <label>
        Статус:
        <select v-model="filters.status" @change="applyFilters" class="border border-gray-300 rounded p-2">
          <option value="">Все</option>
          <option value="completed">Завершенные</option>
          <option value="in progress">В ожидании</option>
          <option value="cancelled">Отмененные</option>
        </select>
      </label>

      <label>
        Дата начала:
        <input type="date" v-model="filters.startDate" @change="applyFilters" class="border border-gray-300 rounded p-2" />
      </label>

      <label>
        Дата конца:
        <input type="date" v-model="filters.endDate" @change="applyFilters" class="border border-gray-300 rounded p-2" />
      </label>
    </div>

    <!-- Export Button -->
    <button @click="exportToExcel" class="bg-green-500 text-white py-2 px-4 rounded hover:bg-green-600 mb-4">
      Экспорт в Excel
    </button>

    <!-- Transactions Table -->
    <div class="overflow-x-auto">
      <table class="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
        <thead>
          <tr class="bg-gray-100">
            <th class="table-header px-4 py-2">ID заказа</th>
            <th class="table-header px-4 py-2">Дата</th>
            <th class="table-header px-4 py-2">Тип</th>
            <th class="table-header px-4 py-2">Мед работник</th>
            <th class="table-header px-4 py-2">Статус</th>
            <th class="table-header px-4 py-2">Итого</th>
            <th class="table-header px-4 py-2">15%</th>
            <th class="table-header px-4 py-2">К ВЫДАЧЕ</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="transaction in transactions" :key="transaction.id" class="hover:bg-gray-50 border-t border-gray-200">
            <td class="table-cell px-4 py-2">{{ transaction.id }}</td>
            <td class="table-cell px-4 py-2">{{ formatDate(transaction.date) }}</td>
            <td class="table-cell px-4 py-2">{{ transaction.type === 'Doctor' ? 'Врач' : 'Медсестра' }}</td>
            <td class="table-cell px-4 py-2">{{ transaction.provider_name }}</td>
            <td class="table-cell px-4 py-2">{{ transaction.status }}</td>
            <td class="table-cell px-4 py-2">{{ formatAsInteger(transaction.amount) }} ₸</td>
            <td class="table-cell px-4 py-2">{{ formatAsInteger(transaction.service_fee) }} ₸</td>
            <td class="table-cell px-4 py-2">{{ formatAsInteger(transaction.net_amount) }} ₸</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import AccountingService from '@/services/AccountingService';

export default {
  data() {
    return {
      summary: {
        doctor_revenue: 0,
        nurse_revenue: 0,
        total_revenue: 0,
        doctor_cancellations: 0,
        nurse_cancellations: 0,
        total_cancellations: 0,
      },
      transactions: [],
      filters: {
        status: '',
        startDate: '',
        endDate: '',
      },
    };
  },
  computed: {
    netIncome() {
      return parseInt(this.summary.total_revenue * 0.15, 10);
    },
  },
  methods: {
    async loadSummary() {
      try {
        this.summary = await AccountingService.getSummary();
      } catch (error) {
        console.error('Error loading summary:', error);
      }
    },
    async loadTransactions() {
      try {
        this.transactions = await AccountingService.getTransactions(this.filters);
      } catch (error) {
        console.error('Error loading transactions:', error);
      }
    },
    applyFilters() {
      this.loadTransactions();
    },
    async exportToExcel() {
      try {
        await AccountingService.exportOrders(this.filters);
      } catch (error) {
        console.error('Error exporting to Excel:', error);
      }
    },
    formatDate(date) {
      const d = new Date(date);
      return d.toLocaleDateString('ru-RU');
    },
    formatAsInteger(value) {
      return parseInt(value, 10);
    }
  },
  created() {
    this.loadSummary();
    this.loadTransactions();
  },
};
</script>
